import { gateway } from "../../../gateway";

export type PayLaterEnabledResponse = { payLaterEnabled: boolean };

/**
 * Public endpoint: no auth required. Returns only payLaterEnabled for the given merchantId.
 */
export const getPayLaterEnabledByMerchantId = async (
  merchantId: string,
): Promise<PayLaterEnabledResponse> => {
  const { data } = await gateway.get<PayLaterEnabledResponse>(
    `/paypal/e-commerce/public/pay-later-enabled/${encodeURIComponent(merchantId.trim())}`,
  );
  return data;
};
